import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-accidental-medical-expenses',
    templateUrl: './accidental-medical-expenses.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccidentalMedicalExpensesComponent implements OnInit {
    constructor(private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_PA_ACCIDENTAL_MEDICAL_EXPENSES]);
    }

    ngOnInit() {
    }
}
